
interface FileDataParams {
	fileName: string;
	fileInput?: ArrayBuffer;
}

export default class FileData {

	public fileName: string;
	public fileInput: ArrayBuffer | undefined;

	public constructor(params: FileDataParams) {
		this.fileName = params.fileName;
		this.fileInput = params.fileInput;
	}
}